import { Snackbar, SnackbarContent } from "@mui/material";

interface ToastProps {
  open: boolean;
  handleClose: () => void;
  autoCloseDuration?: number;
  message: string;
}

const Toast = ({
  open,
  handleClose,
  autoCloseDuration = 3000,
  message,
}: ToastProps) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoCloseDuration}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      onClose={handleClose}
    >
      <SnackbarContent
        style={{
          backgroundColor: "#328734",
          cursor: "pointer",
        }}
        message={<span id="client-snackbar">{message}</span>}
      />
    </Snackbar>
  );
};

export default Toast;
